<div class="my-3 mx-6">
  <div class="flex flex-row justify-between items-center">
    <button
      class="!p-0 !m-0 !border-0 !bg-transparent !shadow-none hover:!bg-transparent focus:!bg-transparent flex-shrink-0 cursor-pointer"
      (click)="goToHomeClicked.emit()"
      (keyup)="goToHomeKeyUp($event)"
    >
      <mat-icon svgIcon="logo-accumate" class="!h-5 !w-auto" />
    </button>

    <!-- search, mode select and navigation items -->
    <div class="flex flex-row items-center">
      <div class="ml-2">
        <app-search-input
          [addressSearchTerm]="headerLocationService.address()"
          (searchTermChanged)="headerLocationService.searchAddress($event)"
        />
      </div>

      @if (navigationItems().length > 0) {
        <mat-chip-listbox
          class="ml-2 accumate-chip-listbox--primary accumate-chip-listbox--no-checkmark accumate-chip-listbox--density-large"
        >
          @for (navigationitem of navigationItems(); track navigationitem.id) {
            <mat-chip-option
              [selected]="navigationitem.isSelected"
              (click)="changeNavigationItem(navigationitem.id)"
              (keydown.enter)="changeNavigationItem(navigationitem.id)"
              (keydown.space)="changeNavigationItem(navigationitem.id)"
              [attr.data-testid]="'subheader-navigation-chip-' + navigationitem.id"
            >
              <mat-icon [svgIcon]="navigationitem.icon" class="icon" />
              <div class="text">
                {{ navigationitem.translationKey | transloco }}
              </div>
            </mat-chip-option>
          }
        </mat-chip-listbox>
      }
    </div>

    <!-- cache, language and user menu -->
    <div class="flex flex-row items-center">
      <button
        mat-button
        class="flex flex-row items-center mr-2 ml-2 !bg-transparent !border-0"
        (click)="openCacheClicked.emit()"
        data-testid="header-cache-button"
        [attr.aria-label]="'Title.MainTitle.Cache' | transloco"
      >
        <mat-icon svgIcon="icn-restore" class="mat-icon-svg-color-accumin-berry-100 flex-shrink-0 flex-grow-0 !h-5 !w-5 !mr-0 !ml-0" />
        <span class="ml-1 text-primary-accumin-berry-100 hidden xl:block text-accumin-berry-100">
          {{ "Title.MainTitle.Cache" | transloco }}
        </span>
      </button>
      <mat-form-field class="rounded-md max-w-32 mr-4 border border-primary-accumin-purple-100 mat-mdc-form-field--density-compact">
        <mat-select [panelWidth]="null" [value]="userLocale()" (selectionChange)="this.languageChanged.emit($event.value)">
          @for (item of languageItems; track item.id) {
            <mat-option [value]="item.id">
              {{ item.id | uppercase }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="flex flex-row items-center">
        <button
          mat-button
          [matMenuTriggerFor]="menu"
          #menuTrigger="matMenuTrigger"
          class="!rounded-full border mdc-button--density-large !h-10"
          [ngClass]="{
            '!bg-primary-accumin-purple-100 border-transparent': !menuTrigger.menuOpen,
            '!bg-primary-accumin-white !border-solid !border-[1px] !border-primary-accumin-purple-100 ': menuTrigger.menuOpen
          }"
        >
          <div class="flex items-center">
            <div class="w-6 h-6 mr-2 ml-2 rounded-full bg-cover bg-no-repeat bg-center">
              <mat-icon
                svgIcon="icn-user"
                [ngClass]="{
                  '!mat-icon-svg-color-white !text-primary-accumin-white': !menuTrigger.menuOpen,
                  '!mat-icon-svg-color-accumin-purple !text-primary-accumin-purple-100': menuTrigger.menuOpen
                }"
              />
            </div>
            <div
              [ngClass]="{
                '!text-primary-accumin-white': !menuTrigger.menuOpen,
                '!text-primary-accumin-purple-100': menuTrigger.menuOpen
              }"
              class="text-xs font-medium mr-2"
              data-testid="header-display-user-name"
            >
              {{ initData().displayUserNameShort }}
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<mat-menu #menu="matMenu" class="user-menu">
  <app-user-menu
    [initData]="initData()"
    [quota]="quota()"
    (changeRight)="configService.changeRight()"
    (logout)="configService.logout()"
    (showMobileTAN)="configService.showMobileTAN()"
    (showPackageOverview)="packageService.showPackageOverviewDialog()"
    [hasAppSynchronizationPermission]="hasAppSynchronizationPermission()"
    [hasShopPermission]="hasShopPermission()"
    [hasChangeRightPermission]="hasChangeRightPermission()"
    (redeemCode)="receptionService.goToLandingPage()"
  />
</mat-menu>
